export default "__VITE_ASSET__BJkDkqJI__"